import React, {useState, useEffect} from 'react';
import {t} from 'ttag';

import Table, {
  TableHead,
  TableBody,
  TableCell
} from '../../../../../components/table/table.jsx';
import Preloader from '../../../../../components/preloader/preloader.jsx';
import EmptyBox from '../../../../../components/empty-box/empty-box.jsx';
import {useAppContext} from '../../../../../app-context.js';
import {useRequest} from '../../../../../common/hooks';
import {getIntegratorClientListReq} from '../../../../../common/api/api.js';

import User from './user/user.jsx';

const UserList = () => {
  const {user} = useAppContext();
  const [userList, setUserList] = useState();
  const {request} = useRequest();

  const getUserList = async () => {
    const res = await request(getIntegratorClientListReq(user.id));

    if (Object.keys(res).length) {
      setUserList(res);
      return;
    }

    setUserList([]);
  };

  useEffect(() => {
    getUserList();
  }, []);

  return (
    <>
      {userList ? (
        userList.length ? (
          <Table>
            <TableHead>
              <TableCell>{t`Date of connection`}</TableCell>
              <TableCell>{t`Domain`}</TableCell>
              <TableCell>{t`Deleted`}</TableCell>
            </TableHead>

            <TableBody>
              {userList.map(item => (
                <User key={item.id} user={item} />
              ))}
            </TableBody>
          </Table>
        ) : (
          <EmptyBox />
        )
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default UserList;
